import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';
import { CheckboxTypesEnum } from '../../../../Common/Forms/enums/checkbox-types.enum';
import { FontAlignmentEnum } from '../../../../Common/Forms/enums/font-alignment.enum';
import { RadioTypesEnum } from '../../../../Common/Forms/enums/radio-types.enum';
import { AbstractBaseStyleFieldComponent } from '../../../../Common/PageBuilder/components/BaseStyleField/abstract-base-style-field.component';
import { DropdownFieldModel } from '../../../../Common/PageBuilder/models/dropdown-field.model';
import { SocialLinkStyleModel } from '../../../../Common/PageBuilder/models/link-style.model';
import { textStyleFontSizeDropdownOptions } from '../../../../Common/PageBuilder/models/text-style-font-size-dropdown-options.model';
import { AbstractPageBuilderService } from '../../../../Common/PageBuilder/services/abstract-page-builder.service';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { SocialLinksStyleFieldModel } from '../../models/social-links-style-field.model';


@Component({
    selector: 'agpr-social-links-style-field',
    templateUrl: './social-links-style-field.component.html',
    styleUrls: ['./social-links-style-field.component.scss'],
    standalone: false
})
export class SocialLinksStyleFieldComponent extends AbstractBaseStyleFieldComponent implements OnInit, OnChanges {
    readonly buttonTypes = ButtonTypesEnum;
    readonly fontAlignmentEnum = FontAlignmentEnum;
    readonly radioTypesEnum = RadioTypesEnum;
    readonly checkboxTypesEnum = CheckboxTypesEnum;

    @Input() declare value: SocialLinkStyleModel;
    @Input() declare field: SocialLinksStyleFieldModel;

    fontSizeField = new DropdownFieldModel(
        null,
        'fontSize',
        '',
        '',
        textStyleFontSizeDropdownOptions,
        'PageBuilder.formField.fontSizeLabel'
    );


    constructor(
        protected coreDialogService: CoreDialogService,
        protected abstractPageBuilderService: AbstractPageBuilderService
    ) {
        super(coreDialogService);
    }

    ngOnInit() {
        if (!this.value) {
            this.value = new SocialLinkStyleModel();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.hasOwnProperty('value')) {
            if (!this.value) {
                this.value = new SocialLinkStyleModel();
            }

            if (!this.value.alignment) {
                this.value.alignment = this.field.defaults.alignment;
            }
            if (!this.value.fontSize) {
                this.value.fontSize = this.field.defaults.fontSize;
            }
            if (!this.value.italics) {
                this.value.italics = this.field.defaults.italics;
            }
            if (!this.value.bold) {
                this.value.bold = this.field.defaults.bold;
            }
            if (!this.value.underlined) {
                this.value.underlined = this.field.defaults.underlined;
            }
        }
    }

}
